import { Component, OnInit, OnDestroy, ChangeDetectorRef, Inject } from '@angular/core';
import { InventoryService } from './inventory.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


declare var Quagga:any;

@Component({
  selector: 'app-tabscan',
  templateUrl: './tabscan.component.html',
  styleUrls: ['./tabscan.component.css']
})
export class TabscanComponent implements OnInit, OnDestroy {

  result:string;
  tForm: FormGroup;

  constructor(
    @Inject(FormBuilder) fb: FormBuilder,
    private _ref: ChangeDetectorRef,
    private _invService: InventoryService
  ) {
    this.tForm = fb.group({
      barcode:[null]
    })
    Quagga.onDetected((res) => this.onDetected(res));
  }

  ngOnInit() {

    //

    this.startScanner();
  }

  ngOnDestroy() {
    console.log('destroyed');
    Quagga.offDetected();
  }

  startScanner() {
    this.tForm.get('barcode').setValue(null);
    Quagga.init({
      inputStream : {
        name : "Live",
        type : "LiveStream",
        target: document.querySelector('#scanner-target'),
        constraints: {
          width: document.getElementById("target-parent").offsetWidth,
          height: 480,
        },
      },
      decoder : {
        readers : ["code_128_reader"]
      },
      locate: true
    }, function(err) {
      if (err) {
        console.log(err);
        return
      }
      console.log("Initialization finished. Ready to start");
      Quagga.start();

    });
  }

  onDetected(res) {
      if(res) {

        this.result = res.codeResult.code;

        this._ref.detectChanges();

        //this._invService.setBarCode(res.codeResult.code);
      }
  }

  barcodeClick() {
    this.result = this.tForm.get('barcode').value;
  }


  // searchResult() {
  //   this._invService.setBarCode(this.result);
  // }

  restart() {
    this.result = null;

  }

  finish() {
    Quagga.stop();
    this._invService.setBarCode(this.result);

  }


  close() {
    Quagga.stop();
    this._invService.setShowScan(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/tabscan.component.ts